// INTERFACES *********

import { appSettings } from 'app/appSettings';
import { CombinationMaterial, DeliveryMethod, EditFlorderDetail, FlowDetail, FlowPlanning, OrderDetail, OrderPlanning, PackingMaterial, Planning, RECURRENCE_PATTERN_WEEKLY, RelocationDetail, RelocationPlanning, } from './florder-detail.interface';

export const BLANK = ' '; // Must be 'true' when == , so don't use '' because it's resolved to false

// INITIAL STATE *********

export const initialStateCombinationMaterial: CombinationMaterial = {
  type: appSettings.MATERIAL_TYPE_COMBINATION,
  palletId: BLANK,
  packingId: BLANK,
  packingStatus: BLANK,
  logisticsVarietyPacking: BLANK,
  packingsPerPallet: null,
  numberOfPallets: null,
  requestedBalance: '',
  packingQuantity: null,
  poNumberItemLevel: '',
  poItemNumber: '',
  contentId: '',
  lineReferenceId: '',
  isNew: true,
};

export const initialStatePackingMaterial: PackingMaterial = {
  type: appSettings.MATERIAL_TYPE_PACKING,
  packingId: BLANK,
  packingStatus: BLANK,
  logisticsVarietyPacking: BLANK,
  requestedBalance: '',
  packingQuantity: null,
  poNumberItemLevel: '',
  poItemNumber: '',
  contentId: '',
  lineReferenceId: '',
  isNew: true,
};

const initialStatePlanning: Planning = {
  loadingDate: null,
  unloadingDate: null,
  requestedUnloadingDate: null,
  confirmedUnloadingDate: null,
};

export const initialStateFlowPlanning: FlowPlanning = {
  ...initialStatePlanning
}

export const initialStateOrderPlanning: OrderPlanning = {
  ...initialStatePlanning,
  exchangePallets: false,
  numberOfExchangePallets: null,
  recurrence: {
    active: false,
    pattern: RECURRENCE_PATTERN_WEEKLY,
    endDate: null,
    weekly: {
      monday: false,
      tuesday: false,
      wednesday: true,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    },
    monthly: {
      day: 1,
      monthPeriodicy1: 1,
      monthPeriodicy2: 1,
      which: 'FIRST',
      weekday: 'WEDNESDAY',
    },
  },
}

export const initialStateRelocationPlanning: RelocationPlanning = {
  ...initialStatePlanning,
  quantity: 1,
}

export const initialStateDeliveryMethod: DeliveryMethod = {
  type: '',
  soldTo: null,
  to: null,
  from: null,
  incoterm: null,
  shippingCondition: null,
  customerReferenceNumber: '',
  originalReferenceNumber: '',
  senderReferenceNumber: '',
  transporter: '',
  licensePlate: '',
  remarks: '',
  remarksHandshaker: '',
};

const initialStateFlorderDetail = {
  status: '',
  deliveryMethod: initialStateDeliveryMethod,
  materials: [],
  etmOrderNumber: '',
  salesOrderNumber: '',
  deliveryNumber: '',
  shipmentNumbers: [],
  registeredBy: '',
  globalType: null,
  updateTime: '',
  updateDate: '',
  updateBy: '',
  customer: null,
};

export const initialStateOrderDetail: OrderDetail = {
  ...initialStateFlorderDetail,
  planning: initialStateOrderPlanning,
  palletQuantity: 0,
  createTemplate: false,
  templateName: '',
  sealNumber: '',
  fullTruck: false,
  ccr: {
    ccrNumber: '',
    sealNumber: '',
    open: true,
    accepted: false,
    declined: false,
    ccrLineItems: [],
  },
  documents: [],
  singleRecurrenceEtmOrderNumbers: [],
}
export const initialStateFlowDetail: FlowDetail = {
  ...initialStateFlorderDetail,
  planning: initialStateFlowPlanning,
  sealNumber: '',
  flowDateErrorObject: {},
};

export const initialStateRelocationDetail: RelocationDetail = {
  ...initialStateFlorderDetail,
  planning: initialStateRelocationPlanning,
  palletQuantity: 0,
  createTemplate: false,
  templateName: '',
  sealNumber: '',
}

export const initialStateEditFlorderDetail: EditFlorderDetail = {
  mode: {
    type: 'order',
    state: 'create',
    editWindow: 'delivery',
    createTemplate: false,
    editTemplate: false,
    openingWindow: null,
    loading: false,
    loadSuccess: false,
    saving: false,
    saveSuccess: false,
    saved: false,
    datesLoading: false,
  },
  availablePickingDates: {
    full: [],
    nonFull: [],
  },
};
